<script>
import lazyLoadComponent from '@router/lazyload-component'
import { priceStatusFilter } from '@utils/filter-value-to-text'
import productMixin from '@/src/mixins/product'

const initData = () => {
  return {
    productId: '',
    title: '',
    state: 0,
    basePrice: 0,
    storeTitle: '',
    price: 0,
    serviceTime: 90,
    bufferTime: 30,
    isFlexible: 0,
    categoryId: 0,
    petCategoryTitle: '',
    petSizeTitle: '',
    commission_value: 0,
    helper_commission_value: 0,
  }
}

export default {
  components: {
    ServiceTree: () => lazyLoadComponent(import("@components/ServiceTree.vue")),
  },
  filters: {
    priceStatusFilter,
  },
  mixins: [productMixin],
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    categoryIndex: {
      type: Number,
      default: 0,
    },
    categoryId: {
      type: Number,
      default: 0
    },
    defaultValue: {
      type: Object,
      default: () => { },
    },
    templateType: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      tableData: [],
      filterData: {
        state: '',
        productId: '',
        categoryId: '',
      },
      priceData: {},
      formIndex: 0,
      dialogVisible: false,
    }
  },
  inject: ['routerType'],
  computed: {
    timeSetShow() {
      return ['service', 'addition'].includes(this.routerType)
    },
    submitData: {
      get() {
        return this.defaultValue
      },
      set(value) {
        this.$emit('update:defaultValue', value)
      },
    },
    submitRules() {
      return {
        serviceTime: [
          {
            required: true,
            message: '請輸入服務時間',
            trigger: 'change',
          },
        ],
        bufferTime: [
          {
            required: true,
            message: '請輸入緩衝時間',
            trigger: 'change',
          },
        ],
        basePrice: [
          {
            required: true,
            message: '請輸入原始價格',
            trigger: 'change',
          },
        ],
        price: [
          {
            required: true,
            message: '請輸入販售價格',
            trigger: 'change',
          },
        ],
      }
    },

    filterTableData() {
      if (!this.tableData) return []
      let filterData = [...this.tableData]
      const state = this.filterData.state
      const productId = this.filterData.productId
      const categoryId = this.filterData.categoryId
      // 狀態filter
      if (state !== '') {
        filterData = filterData.filter(item => {
          return item.state === state
        })
      }
      // 分店filter
      if (productId !== '') {
        filterData = filterData.filter(item => {
          return item.productId === productId
        })
      }

      // 體型filter => sizeId = categoryId = 體型ID
      if (categoryId !== '') {
        filterData = filterData.filter(item => {
          return item.sizeId === categoryId
        })
      }
      filterData = this.filterProductInMixin(filterData, 'productId')
      return filterData
    },
    filterProducts() {
      return this.filterProductInMixin(this.products)
    },
    isEditMode() {
      return this.defaultValue.id
    },
    isPriceNone() {
      for (let i = 0, len = this.tableData.length; i < len; i++) {
        let validate = true
        const { price, basePrice, serviceTime, bufferTime } = this.tableData[i]
        if (isNaN(parseInt(price)) || parseInt(price) < 0) validate = false
        if (isNaN(parseInt(basePrice)) || parseInt(basePrice) < 0) validate = false
        if (isNaN(parseInt(serviceTime)) || parseInt(serviceTime) < 0) validate = false
        if (isNaN(parseInt(bufferTime)) || parseInt(bufferTime) < 0) validate = false
        if (!validate) {
          return true
        }
      }
      return false
    },
    isService() {
      return this.$route.params.type !== 'addition'
    },
    // 服務/加購/住宿 search模板
    searchTableTemplate() {
      return ['service', 'addition', 'daycare'].includes(this.routerType)
    },
    // 服務/加購/住宿 模板
    tempType1() {
      return ['service', 'addition', 'daycare'].includes(this.routerType)
    },
  },
  watch: {
    submitData(nvl, ovl) {
      this.setTableData()
    },
  },
  created() {
    if (!this.isEditMode) {
      this.getDefaultPrices()
    } else {
      this.setTableData()
    }
    this.setTemplateDefaultValue()
  },
  methods: {
    /**
     * @description 將首項參數套用至所有分類
     */
    toAllCategory() {
      try {
        if (this.isEditMode) {
          const { serviceTime, bufferTime, prices } = this.tableData[0]
          for (let i = 1, len = this.tableData.length; i < len; i++) {
            this.$set(this.tableData[i].prices[0], 'basePrice', prices[0].basePrice)
            this.$set(this.tableData[i].prices[0], 'price', prices[0].price)
            this.$set(this.tableData[i].prices[0], 'helper_commission_value', prices[0].helper_commission_value)
            this.$set(this.tableData[i].prices[0], 'commission_value', prices[0].commission_value)
            this.$set(this.tableData[i].prices[0], 'costPrice', prices[0].costPrice)
            this.$set(this.tableData[i], 'bufferTime', bufferTime)
            this.$set(this.tableData[i], 'serviceTime', serviceTime)
          }
        } else {
          const { serviceTime, bufferTime, price, basePrice, helper_commission_value, commission_value, costPrice } = this.tableData[0]
          for (let i = 1, len = this.tableData.length; i < len; i++) {
            this.$set(this.tableData[i], 'basePrice', basePrice)
            this.$set(this.tableData[i], 'price', price)
            this.$set(this.tableData[i], 'helper_commission_value', helper_commission_value)
            this.$set(this.tableData[i], 'commission_value', commission_value)
            this.$set(this.tableData[i], 'costPrice', costPrice)
            this.$set(this.tableData[i], 'bufferTime', bufferTime)
            this.$set(this.tableData[i], 'serviceTime', serviceTime)
          }
        }

      } catch (error) {
        console.error(error.message)
      }

    },
    /**
     * @description 獲取所有分店
     */
    async tryToFetchProduct() {
      const { items } = await this.$store.dispatch('product/fetchList', {
        limit: 10000,
        page: 1,
        paginate: 0
      })
      return items
    },
    /**
     * @description 如果是從SPA開窗，那要另外設定其value
     */
    async setTemplateDefaultValue() {
      if (this.templateType === 'tempSpa') {
        const items = await this.tryToFetchProduct()
        const submitStore = items.filter((location) => this.defaultValue.storeIds.includes(location.id))
        this.$set(this.defaultValue, 'serviceCategoryIds', this.defaultValue.sizeIds)
        this.$set(this.defaultValue, 'storeIds', submitStore)
      }
    },
    setTableData() {
      if (this.submitData.petSizes) {
        this.tableData = this.submitData.petSizes
      }
    },
    getDefaultPrices() {
      this.tableData = []
      let num = 0
      this.products.forEach((store) => {
        this.category[this.categoryIndex].children.forEach((cat) => {
          num++
          this.tableData.push({
            ...initData(),
            storeTitle: store.name,
            productId: store.id,
            title: this.defaultValue.title,
            petCategoryTitle: this.category[this.categoryIndex].categoryTitle,
            petSizeTitle: cat.title,
            categoryId: cat.id,
            catchId: num
          })
        })
      })
      this.submitData.prices = this.tableData
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    /**
     * @description 按下某列，打開視窗
     */
    goToDetail(row, event, column) {
      this.formIndex = row.index
      this.priceData = { ...this.filterTableData[this.formIndex] }

      if (this.isEditMode) {
      } else {
        this.$set(this.filterTableData[this.formIndex], 'basePrice', +this.priceData.basePrice)
        this.$set(this.filterTableData[this.formIndex], 'price', +this.priceData.price)
        this.$set(this.filterTableData[this.formIndex], 'isFlexible', this.priceData.isFlexible)
        this.$set(this.filterTableData[this.formIndex], 'bufferTime', +this.priceData.bufferTime)
        this.$set(this.filterTableData[this.formIndex], 'serviceTime', +this.priceData.serviceTime)
      }
    },
    handleSelectionChange(selected) {
      this.$emit('updateSelectedPrices', selected)
    },
    /**
     * @description 因為vue無法監聽太深的值，所以儲存前要再更改過其變動的值，並且改變值的狀態
     */
    transformIntoArray() {
      this.$set(this.priceData.prices[0], 'basePrice', +this.priceData.basePrice)
      this.$set(this.priceData.prices[0], 'price', +this.priceData.price)
      this.$set(this.priceData.prices[0], 'isFlexible', +this.priceData.isFlexible)
      this.priceData.serviceTime = +this.priceData.serviceTime
      this.priceData.bufferTime = +this.priceData.bufferTime
    },
    validatePriceData() {
      try {
        let validate = true
        const { basePrice, bufferTime, serviceTime, price } = this.priceData
        if (parseInt(bufferTime) < 0) validate = false
        if (parseInt(serviceTime) < 0) validate = false
        if (parseInt(basePrice) < 0) validate = false
        if (parseInt(price) < 0) validate = false
        if (!validate) {
          this.$message({
            type: 'error',
            message: `各欄位皆需大於等於0`,
          })
        }
        return validate
      } catch (error) {
        console.error(error.message)
      }
    },
    async tryToSave() {
      try {
        if (!this.validatePriceData()) return
        await this.$refs.form.validate()
        if (this.isEditMode) {
          this.transformIntoArray()
          const changeDataId = this.priceData.id
          this.tableData.forEach((item, index) => {
            if (changeDataId === item.id) {
              this.tableData[index] = { ...this.priceData }
            }
          })
          this.$emit('store', 'price')
        } else {
          this.tableData.forEach((item, index) => {
            if (this.priceData.catchId === item.catchId) {
              this.tableData[index] = { ...this.priceData }
            }
          })
          this.tableData = [...this.tableData]
          this.submitData.prices = [...this.tableData]
          // this.setFilterTableData()
        }
        this.dialogVisible = false
      } catch {

      } finally {

      }

    },
    tryToFetchListFilter() {

    },
    onFilterReset() {

    },
    async selectOn() {
      const ids = this.selectedPrices.map(item => item.id)
      const url = this.isService ? 'product/serviceUpdateState' : 'product/additionUpdateState'
      await this.$store.dispatch(`${url}`, {
        ids,
        state: 1
      })
      this.$emit('update')
    },
    async selectOff() {
      try {
        await this.$confirm('服務上架中，確定要下架嗎？', '確認下架', {
          confirmButtonText: '確定',
          showCancelButton: true,
          type: 'warning',
          center: true,
        })
        const ids = this.selectedPrices.map(item => item.id)
        const url = this.isService ? 'product/serviceUpdateState' : 'product/additionUpdateState'
        await this.$store.dispatch(`${url}`, {
          ids,
          state: 0
        })
        this.$emit('update')
      } catch {

      } finally {

      }
    },
    validate() {
      return this.$refs.form.validate()
    },

  },
}
</script>

<template>
  <div :class="$style.content">
    <BaseTableSearch v-if="searchTableTemplate" v-slot="{ fields }" hide-action :default-value="filterData"
      class="isForTab" :reset-btn-style="`width:150px;height:44px;margin-bottom:14px;`" @reset="onFilterReset"
      @tryToFetchList="tryToFetchListFilter">
      <el-form-item v-if="isEditMode" prop="state">
        <el-select v-model.number="fields.state" placeholder="上架狀態">
          <el-option label="所有狀態" value=""></el-option>
          <el-option label="上架中" :value="1"></el-option>
          <el-option label="已下架" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="productId">
        <el-select v-model="fields.productId" placeholder="所有地點">
          <el-option label="所有分店" value=""></el-option>
          <el-option v-for="(product, index) in filterProducts" :key="index" :label="product.name" :value="product.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="isEditMode" prop="categoryId">
        <el-select v-model="fields.categoryId" :placeholder="`${$t('reserve.CLIENT')}${$t('member.BODY_TO_TYPE')}`">
          <el-option :label="`所有${$t('member.BODY_TO_TYPE')}`" value></el-option>
          <el-option v-for="item in category[categoryIndex].children" :key="item.id" :label="item.categoryTitle"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="is-round" type="primary" @click="toAllCategory">皆同第一列</el-button>
      </el-form-item>
    </BaseTableSearch>
    <!-- 一般時間 -->
    <template v-if="false">
      <div v-for="(item, key, index) in filterTableData" :key="key" :class="$style.borderBottom">
        <el-form :ref="`form${key}`" :model="filterTableData[key]" label-position="top"
          :style="key === '1' ? 'height:175px' : 'height:auto'" :class="$style.elForm">
          {{ key }}
          <el-row :gutter="20" :class="$style.timeRow">
            <el-col :sm="4" :span="12">
              <el-form-item label="分店及分類名稱" prop="lastOrder" style="overflow-x:auto;">
                <div>{{ filterTableData[key].storeTitle }}</div>
                <div>{{ filterTableData[key].sizeTitle }}</div>
              </el-form-item>
            </el-col>
            <el-col :sm="4" :span="12">
              <el-form-item label="服務時間（分鐘）" prop="lastOrder" style="overflow-x:auto;">
                <el-input v-model.number="filterTableData[key].serviceTime" class="bg-white is-border" type="number"
                  min="0" />
              </el-form-item>
            </el-col>
            <el-col :sm="4" :span="12">
              <el-form-item label="緩衝時間（分鐘）" prop="lastOrder" style="overflow-x:auto;">
                <el-input v-model.number="filterTableData[key].bufferTime" class="bg-white is-border" type="number"
                  min="0" />
              </el-form-item>
            </el-col>
            <el-col :sm="4" :span="12">
              <el-form-item label="原價" prop="lastOrder" style="overflow-x:auto;">
                <el-input v-model.number="filterTableData[key].basePrice" class="bg-white is-border" type="number"
                  min="0" />
              </el-form-item>
            </el-col>
            <el-col :sm="4" :span="12">
              <el-form-item label="售價" prop="lastOrder" style="overflow-x:auto;">
                <el-input v-model.number="filterTableData[key].price" class="bg-white is-border" type="number" min="0" />
                <el-checkbox v-model="filterTableData[key].isFlexible" :true-label="1" :false-label="0"
                  style="margin-left:5px;">起以上
                </el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :sm="4" :span="12">
              <el-form-item label="狀態" prop="lastOrder" style="overflow-x:auto;">
                <el-switch v-model="filterTableData[key].state" active-text="上架" inactive-text="下架" :active-value="1"
                  :inactive-value="0">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </template>
    <!-- 一般/加購/安親 服務模板 -->
    <el-table v-if="tempType1 && Object.keys(submitData).length > 0" ref="multipleTable" :data="filterTableData"
      :class="$style['customTable']" :row-class-name="tableRowClassName" @row-click="goToDetail"
      @selection-change="handleSelectionChange">
      <!-- 新增模式 -->
      <template v-if="!isEditMode">
        <el-table-column v-slot="{ row }" label="分店及分類名稱" prop="storeTitle" min-width="25">
          <div>{{ row.storeTitle }}</div>
          <div>{{ row.petSizeTitle }}</div>
        </el-table-column>

        <el-table-column v-if="timeSetShow" v-slot="{ row }" label="服務時間（分鐘）" prop="petSizeTitle" min-width="25">
          <el-input v-model.number="row.serviceTime" class="bg-white is-border" type="number" min="0" />
        </el-table-column>

        <el-table-column v-if="timeSetShow" v-slot="{ row }" label="緩衝時間（分鐘）" min-width="25">
          <el-input v-model.number="row.bufferTime" class="bg-white is-border" type="number" min="0" />
        </el-table-column>

        <el-table-column v-if="(submitData.commission_type === '%')" v-slot="{ row }" label="美容師分潤比例(%)"
          min-width="25">
          <el-input v-model.number="row.commission_value" class="bg-white is-border" type="number" min="0" max="100" />
        </el-table-column>
        <el-table-column v-if="(submitData.commission_type === 'fixed' || !submitData.commission_type)"
          v-slot="{ row }" label="美容師分潤金額" min-width="25">
          <el-input v-model.number="row.commission_value" class="bg-white is-border" type="number" min="0" />
        </el-table-column>

        <el-table-column v-if="(submitData.commission_type === '%')" v-slot="{ row }" label="助理分潤比例(%)"
          min-width="25">
          <el-input v-model.number="row.helper_commission_value" class="bg-white is-border" type="number" min="0"
            max="100" />
        </el-table-column>
        <el-table-column v-if="(submitData.commission_type === 'fixed' || !submitData.commission_type)"
          v-slot="{ row }" label="助理分潤金額" min-width="25">
          <el-input v-model.number="row.helper_commission_value" class="bg-white is-border" type="number" min="0" />
        </el-table-column>

        <el-table-column v-slot="{ row }" label="成本價" min-width="28">
          <el-input v-model.number="row.costPrice" class="bg-white is-border" type="number" min="0" />
        </el-table-column>

        <el-table-column v-slot="{ row }" label="原價" min-width="28">
          <el-input v-model.number="row.basePrice" class="bg-white is-border" type="number" min="0" />
        </el-table-column>

        <el-table-column v-slot="{ row }" label="售價" min-width="48">
          <div style="display:flex;align-items: flex-end;">
            <el-input v-model.number="row.price" class="bg-white is-border" type="number" min="0" />
            <el-checkbox v-model="row.isFlexible" :true-label="1" :false-label="0" style="margin-left:5px;">起以上
            </el-checkbox>
          </div>
        </el-table-column>

        <el-table-column v-slot="{ row }" label="狀態" prop="state" min-width="40">
          <el-switch v-model="row.state" active-text="上架" inactive-text="下架" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-table-column>
      </template>
      <template v-else>
        <!-- <el-table-column v-if="isEditMode" type="selection" min-width="40"></el-table-column> -->
        <el-table-column v-slot="{ row }" label="分店及分類名稱" prop="petSizeTitle" min-width="25">
          <div>{{ row.storeTitle }}</div>
          <div>{{ row.sizeTitle }}</div>
        </el-table-column>

        <el-table-column v-slot="{ row }" label="服務時間(分鐘)" min-width="25">
          <el-input v-model.number="row.serviceTime" class="bg-white is-border" type="number" min="0" />
        </el-table-column>

        <el-table-column v-slot="{ row }" label="緩衝時間(分鐘)" min-width="25">
          <el-input v-model.number="row.bufferTime" class="bg-white is-border" type="number" min="0" />
        </el-table-column>

        <el-table-column v-if="(submitData.commission_type === '%')" v-slot="{ row }" label="美容師分潤比例(%)"
          min-width="25">
          <el-input v-model.number="row.prices[0].commission_value" class="bg-white is-border" type="number" min="0"
            max="100" />
        </el-table-column>
        <el-table-column v-if="(submitData.commission_type === 'fixed' || !submitData.commission_type)"
          v-slot="{ row }" label="美容師分潤金額" min-width="25">
          <el-input v-model.number="row.prices[0].commission_value" class="bg-white is-border" type="number" min="0" />
        </el-table-column>

        <el-table-column v-if="(submitData.commission_type === '%')" v-slot="{ row }" label="助理分潤比例(%)"
          min-width="25">
          <el-input v-model.number="row.prices[0].helper_commission_value" class="bg-white is-border" type="number"
            min="0" max="100" />
        </el-table-column>
        <el-table-column v-if="(submitData.commission_type === 'fixed' || !submitData.commission_type)"
          v-slot="{ row }" label="助理分潤金額" min-width="25">
          <el-input v-model.number="row.prices[0].helper_commission_value" class="bg-white is-border" type="number"
            min="0" />
        </el-table-column>

        <el-table-column v-slot="{ row }" label="成本價" min-width="28">
          <el-input v-model.number="row.prices[0].costPrice" class="bg-white is-border" type="number" min="0" />
        </el-table-column>

        <el-table-column v-slot="{ row }" label="原價" min-width="28">
          <el-input v-model.number="row.prices[0].basePrice" class="bg-white is-border" type="number" min="0" />
        </el-table-column>


        <el-table-column v-slot="{ row }" label="售價" min-width="48">
          <div style="display:flex;align-items: flex-end;">
            <el-input v-model.number="row.prices[0].price" class="bg-white is-border" type="number" min="0" />
            <el-checkbox v-model="row.prices[0].isFlexible" :true-label="1" :false-label="0" style="margin-left:5px;">起以上
            </el-checkbox>
          </div>
        </el-table-column>

        <el-table-column v-slot="{ row }" label="狀態" prop="state" min-width="40" align="center">
          <el-switch v-model="row.state" active-text="上架" inactive-text="下架" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-table-column>

      </template>
    </el-table>
    <!-- SPA介紹模板 -->
    <template v-if="templateType === 'tempSpa'">
      <div :class="$style.tempSpaPriceUpper" v-if="isEditMode">
        <div>
          <p :class="$style['tempSpaPriceUpper__title']">服務時間<span>&nbsp依所選相關服務變動</span></p>
          <p :class="$style['tempSpaPriceUpper__minutePrice']">{{ submitData.minTime }} - {{
            submitData.maxTime
          }}<span>&nbsp分鐘</span></p>
        </div>
        <div>
          <p :class="$style['tempSpaPriceUpper__title']">價格項目<span>&nbsp依所選相關服務變動</span></p>
          <p :class="$style['tempSpaPriceUpper__minutePrice']">NT$ {{ submitData.minPrice }} - NT$ {{
            submitData.maxPrice
          }}<span>&nbsp元</span></p>
        </div>
      </div>
      <div :class="$style['content__serviceTree']">
        <ServiceTree ref="serviceTree" v-model="submitData" :default-value="defaultValue" />
      </div>
    </template>
    <el-dialog v-if="dialogVisible" :visible.sync="dialogVisible" top="0" append-to-body :close-on-click-modal="false">
      <span slot="title" style="font-size:18px;line-height:24px">{{ priceData.storeTitle }} / {{
        priceData.petSizeTitle
      }}
        編輯價格設定</span>
      <div :class="$style.dialogSwitch">
        <div class="inline-between ">
          是否上架服務
        </div>
        <el-switch v-model="priceData.state" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0">
        </el-switch>
      </div>
      <div class="only-bottom-line"></div>
      <el-form ref="form" :rules="submitRules" :model="priceData" label-width="100px" label-position="top"
        :class="$style.dialogFormItem">
        <el-form-item label="服務時間" v-if="timeSetShow" prop="serviceTime">
          <div class="input-inline">
            <el-input v-model="priceData.serviceTime" placeholder="" class="bg-white is-border" type="number" min="0">
            </el-input>
            <span class="text">分鐘</span>
          </div>
        </el-form-item>
        <el-form-item label="緩衝時間" v-if="timeSetShow" prop="bufferTime">
          <div class="input-inline">
            <el-input v-model="priceData.bufferTime" placeholder="" class="bg-white is-border" type="number"
              min="0"></el-input>
            <span class="text">分鐘</span>
          </div>
        </el-form-item>
        <el-form-item label="原價" prop="basePrice">
          <div class="input-inline">
            <el-input v-model="priceData.basePrice" placeholder="" class="bg-white is-border" type="number"
              min="0"></el-input>
            <span class="text">元</span>
          </div>
        </el-form-item>
        <el-form-item label="售價" prop="price">
          <div class="input-inline">
            <el-input v-model="priceData.price" placeholder="" class="bg-white is-border" type="number"
              min="0"></el-input>
            <span class="text">元</span>
            <el-checkbox v-model="priceData.isFlexible" :true-label="1" :false-label="0">起以上</el-checkbox>
          </div>
        </el-form-item>
      </el-form>

      <div class="btn-group-inline" style="padding-top:15px">
        <el-button class="is-round " @click="dialogVisible = false">取消</el-button>
        <el-button class="is-round " type="primary" @click="tryToSave">儲存變更</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.content {
  padding: 20px;
  background-color: white;
  margin-bottom: 20px;

  &__serviceTree {
    padding: 20px 0;
  }
}

.customTable {
  :global {
    .el-switch {
      width: 150px;
    }

    .el-table__body-wrapper {
      overflow: scroll;
    }

    .el-table__header {
      width: 100% !important;
    }

    .el-table__body {
      width: 100% !important;
    }

    .el-table-column-selection {
      width: 100px;
    }
  }
}

.dialogSwitch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px;
}

.dialogFormItem {
  :global {
    .el-form-item {
      margin-top: 12px;
      margin-bottom: 12px;
    }
  }
}

.tempSpaPriceUpper {
  display: flex;
  background-color: #F9F9FB;

  &>div {
    padding: 20px;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  &__title {
    font-size: 14px;
    color: $color-secondary;

    span {
      font-size: 12px;
      color: #6C6B6B;
    }
  }

  &__minutePrice {
    font-size: 16px;
    color: $color-primary;

    span {
      font-size: 12px;
      color: $color-secondary;
    }
  }
}
</style>
